import {useState} from 'react';
import { Link } from "react-router-dom";

// Images
import InstagramIcon from '../images/icons/instagram-brands-solid-full.svg';
import BlueSkyIcon from '../images/icons/bluesky-brands-solid-full.svg';
import CommissionIcon from '../images/icons/briefcase-solid-full.svg';
import PortfolioIcon from '../images/icons/palette-solid-full.svg';
import MarathonLogo from '../images/icons/marathon_logo.svg';
import MenuIcon from '../images/icons/bars-solid-full.svg';
import ShopIcon from '../images/icons/shop-solid-full.svg';
import DestinyIcon from '../images/icons/destiny.svg';
import BGImage from '../images/home-header.webp';
import HaloIcon from '../images/icons/halo.svg';
import CloseIcon from '../images/icons/x.svg';
import Logo from '../images/dragon.png';


function Navbar()  {

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    function setMobileOpen(value: boolean) {
        setIsMobileMenuOpen(value);
    }

    return (
        <div className="navbar-container">
            <Link to="/" className={`logo-container ${isMobileMenuOpen === true && "d-none"}`} onClick={() => {setMobileOpen(false)}}>
                <img src={Logo} alt='logo' className="logo" />
            </Link>
            <div className={`nav-menu ${isMobileMenuOpen ? "mobile" : ""}`}>

                <div className="close-icon" onClick={() => {setIsMobileMenuOpen(false)}}>
                    <img src={CloseIcon} />
                </div>

                <Link to="/portfolio" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={PortfolioIcon} /></span>
                    <span className="tag">PORTFOLIO</span>
                </Link>
                
                <Link to="https://ko-fi.com/vulshokbersrker/commissions" target="_blank" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={CommissionIcon} /></span>
                    <span className="tag">COMMISSIONS</span>
                </Link>

                <Link to="/destiny-2" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={DestinyIcon} /></span>
                    <span className="tag">DESTINY</span>
                </Link>
            
                <Link to="/halo-infinite" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={HaloIcon} /></span>
                    <span className="tag">HALO INFINITE</span>
                </Link>

                <Link to="/marathon" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={MarathonLogo} /></span>
                    <span className="tag">MARATHON</span>
                </Link>
            
                <Link to="/store" className="nav-link" onClick={() => {setMobileOpen(false)}}>
                    <span className="nav-icon"><img src={ShopIcon} /></span>
                    <span className="tag">STORE</span>
                </Link>

                <div className="social-icons mobile" onClick={() => {setMobileOpen(false)}}>
                    <Link to="https://www.instagram.com/vulshokbersrker/?hl=en" target="_blank" rel="noopener noreferrer" className="nav-link">
                        <img src={InstagramIcon} className="icon-red materialIcon" alt="" />
                    </Link>

                    <Link to="https://bsky.app/profile/vbdesigns.net" target="_blank" rel="noopener noreferrer" className="nav-link">
                        <img src={BlueSkyIcon} className="icon-red materialIcon" alt="" />
                    </Link>
                </div>
                
            </div>  

            <div className="social-icons">
                <Link to="https://www.instagram.com/vulshokbersrker/?hl=en" target="_blank" rel="noopener noreferrer" className="nav-link">
                    <img src={InstagramIcon} className="icon-red materialIcon" alt="" />
                </Link>

                <Link to="https://bsky.app/profile/vbdesigns.net" target="_blank" rel="noopener noreferrer" className="nav-link">
                    <img src={BlueSkyIcon} className="icon-red materialIcon" alt="" />
                </Link>
            </div>

            {/* Mobile Section */}
            {isMobileMenuOpen === false && 
                <div className="menu-icon" onClick={() => {setIsMobileMenuOpen(true)}}>
                    <img src={MenuIcon} />
                </div>
            }
            
            <div className="bg-navbar-container">
                <div className="bg-navbar-container__inner">
                    <img
                        src={BGImage}
                        alt={``} 
                        loading="eager"
                    />
                </div>
            </div>
        </div>
    );
}

export default Navbar;
